<template>
    <v-form ref="resetForm" v-model="resetValid" lazy-validation @submit.prevent="validate">
        <div v-if="!sendMailSuccess">
          <h2 class="title">Please enter the mail you are registered with:</h2>
        </div>
        <div class="py-4" v-if="!sendMailSuccess">
            <v-text-field ref="email" 
            v-model="email" 
            :rules="genericRules.emailRules" 
            label="E-mail" 
            required 
            color="grey" 
            outlined 
            dense 
            validate-on-blur 
            filled 
            hide-details="auto" 
            clearable 
            clear-icon="mdi-refresh" 
            @blur="resetField($refs.email)" 
            :loading="sendingResetLink" 
            >
            </v-text-field>
        </div>
        <div class="py-4" v-if="sendMailSuccess">
          <p class="body-1">
            Please check <span class="textLinks--text">{{this.email}}</span> for further instructions
          </p>
        </div>
        <div class="py-4">
          <v-btn type="submit" color="blue darken-1 white--text" :disabled="sendingResetLink" 
          :loading="sendingResetLink"
          @click="validate">Send</v-btn>
        </div>
    </v-form>
</template>
<script>
import {
  SEND_PASSWORD_RESET
} from "@/store/actions.type"
import formMixins from "@/mixins/mixin-forms"
import fieldCheckMixins from "@/mixins/mixin-field-checks"

export default {
  mixins: [formMixins, fieldCheckMixins],
  data() {
    return {
      email: '',
      resetValid: false,
      sendingResetLink: false,
      sendMailSuccess: false
    }
  },

  methods: {
    validate() {
      if (this.$refs.resetForm.validate()) {
        this.sendingResetLink = true
        this.$store.dispatch(SEND_PASSWORD_RESET, {
          email: this.email
        })
        .then(() => {
          this.sendingResetLink = false
          this.sendMailSuccess = true
        })
      }
    }
  }
}
</script>